'use client'

import { useEffect } from 'react'
import {
  registerDeferredTag,
  type DeferredTagSpec,
} from '@/lib/tracking/deferred-tags'

/**
 * Arms the two-stage loader for one third-party library (see
 * `lib/tracking/deferred-tags.ts`). `spec` must be a module-level constant —
 * it is an effect dependency. useEffect is the right tool here: a subscription
 * to window events and timers with cleanup, not derived state. With
 * `enabled=false` (consent denied, id unset) nothing is subscribed.
 */
export function useDeferredTag(spec: DeferredTagSpec, enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return
    return registerDeferredTag(spec)
  }, [enabled, spec])
}
